export default __webpack_public_path__ + "static/media/alert-icon-yellow.58a35584.svg";